import { useEffect, useState, useCallback } from "react";
import { api } from "../api/client";
import Navbar from "../components/Navbar";
import VehicleCard from "../components/VehicleCard";
import { Input } from "../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Search } from "lucide-react";

const CATEGORIES = ["all", "sedan", "suv", "hatchback", "luxury", "bike"];

export default function Vehicles() {
  const [vehicles, setVehicles] = useState([]);
  const [q, setQ] = useState("");
  const [category, setCategory] = useState("all");
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const params = {};
    if (q) params.q = q;
    if (category !== "all") params.category = category;
    try {
      const { data } = await api.get("/vehicles", { params });
      setVehicles(data);
    } catch (err) {
      console.error("[vehicles] failed to load:", err?.message || err);
    } finally { setLoading(false); }
  }, [q, category]);

  useEffect(() => { load(); }, [category, load]);

  return (
    <div className="min-h-screen bg-[#050B14] text-white">
      <Navbar />
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 mb-3">Marketplace</p>
        <h1 className="text-4xl sm:text-5xl font-light tracking-tighter mb-10">Browse vehicles.</h1>

        <div className="flex flex-col md:flex-row gap-4 mb-10">
          <form onSubmit={(e) => { e.preventDefault(); load(); }} className="flex-1 relative">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
            <Input
              data-testid="vehicles-search-input"
              value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name or brand…"
              className="bg-[#050B14] border-white/10 text-white pl-11 py-6 focus:border-sky-400 focus:ring-1 focus:ring-sky-400"
            />
          </form>
          <Select value={category} onValueChange={setCategory}>
            <SelectTrigger data-testid="vehicles-category-select" className="w-full md:w-56 bg-[#050B14] border-white/10 text-white py-6">
              <SelectValue placeholder="Category" />
            </SelectTrigger>
            <SelectContent className="bg-[#0A111A] border-white/10 text-white">
              {CATEGORIES.map((c) => <SelectItem key={c} value={c} className="capitalize focus:bg-white/5">{c}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>

        {loading ? (
          <p className="text-slate-400">Loading…</p>
        ) : vehicles.length === 0 ? (
          <div className="bg-[#0A111A]/60 border border-white/10 rounded-2xl p-12 text-center">
            <p className="text-slate-400">No vehicles match your search.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {vehicles.map((v) => <VehicleCard key={v.id} vehicle={v} />)}
          </div>
        )}
      </div>
    </div>
  );
}
